<template>
  <messenger-qr-code-view-layout
    :channel-title="viewSettings.channel.name"
    :channel-description="viewSettings.channel.description"
    :channel-type="viewSettings.channel.type"
    :content-title="viewSettings.title"
    :content-description="viewSettings.description"
    :button-text="viewSettings.buttonText"
    :scan-qr-text="$t('messengerWidget.scanQrToOpenChat')"
    :contact-data="contactData"
    :qr-code-logo-url="facebookLogo"
    :show-qr-code="viewSettings.showQrCode"
    open-href-in-new-window
    @back="$emit('back')"
    @resize="$emit('resize', $event)"
  >
    <template v-slot:alert>
      <slot name="alert"></slot>
    </template>

    <template v-slot:not-exists-contact-data>
      <slot name="not-exists-contact-data"></slot>
    </template>
  </messenger-qr-code-view-layout>
</template>

<script setup lang="ts">
import type { MessengerFacebookViewSettings, QrCodeContactData } from '@widgets/messenger/types'
import MessengerQrCodeViewLayout from '@widgets/messenger/components/MessengerQrCodeViewLayout.vue'
import { computed } from '@/composition/vue/compositionApi'
import facebookLogo from '@/assets/images/facebook.svg'

const props = defineProps<{
  viewSettings: MessengerFacebookViewSettings
}>()

defineEmits<{
  (e: 'back'): void
  (e: 'resize', height: number): void
}>()

const contactData = computed(() => {
  if (!props.viewSettings.facebookChatUrl) {
    return undefined
  }
  return {
    href: props.viewSettings.facebookChatUrl,
  } satisfies QrCodeContactData
})
</script>
